export const env = {
  BASE_URL: import.meta.env.VITE_APP_API_SERVER,
};
